import { HeaderWrapper } from 'layouts';
import type { Event } from 'models';
import { useMemo } from 'react';
import { HeaderAsset, HeaderContent, ScrollToTop } from 'ui';
import { InviteesCount } from '../../components';
import { useGetEventTagsProperties, useGetEventTimeInfo } from '../../hooks';
import { useGetEventCoverPhoto } from '../hooks';
import { ExtraActions } from './extra-actions';
import { useGetEventAction } from './hooks';

type P = {
  event: Event;
  navigateToCalendar: () => void;
  navigateToEventDetail: (id: string) => Promise<void>;
};

const EventHeaderDefault = ({ event, navigateToCalendar, navigateToEventDetail }: P) => {
  const { endTime, goingCount, name, notGoingCount, pendingCount, startTime, status, type } = event;
  const tags = useGetEventTagsProperties({ endTime, eventType: type, startTime, status });
  const getTimeInfo = useGetEventTimeInfo();
  const coverPhotoSource = useGetEventCoverPhoto(event);
  const getEventActions = useGetEventAction({
    navigateToCalendar,
    navigateToEventDetail,
  });

  const { actions, contextHolders } = useMemo(() => getEventActions({ event }), [event, getEventActions]);

  return (
    <>
      <ScrollToTop />
      <HeaderWrapper
        left={
          <HeaderAsset
            image={{
              alt: 'Event cover photo',
              src: coverPhotoSource,
            }}
          />
        }
        right={
          <HeaderContent
            actions={actions}
            extra={<ExtraActions event={event} />}
            tags={tags}
            timeInfo={getTimeInfo({ event })}
            title={name}
          >
            <InviteesCount
              eventType={type}
              inviteesCount={{
                going: goingCount,
                notGoing: notGoingCount,
                pending: pendingCount,
              }}
            />
          </HeaderContent>
        }
      />
      {contextHolders}
    </>
  );
};

export default EventHeaderDefault;
